import {
  faTableRows,
  faTableRowsAddAbove,
  faTableRowsAddBelow,
  faTableRowsRemoveBelow
} from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { Editor } from '@tiptap/react'
import clsx from 'clsx'
import { Tooltip } from '~/components/Global/Elements/Tooltip/Tooltip'
import { editorDropdownItem, editorTableMenuDanger } from './EditorInput.css'
import { SplitButtonDropdown } from './SplitButtonDropdown'

export const TableRowDropdown = ({ editor }: { editor: Editor }) => (
  <Tooltip direction="bottom" text="Lignes" asChild>
    <SplitButtonDropdown
      icon={<FontAwesomeIcon icon={faTableRows} />}
      onMainClick={() => editor.chain().focus().addRowAfter().run()}
    >
      <button
        type="button"
        className={editorDropdownItem}
        onClick={() => editor.chain().focus().addRowBefore().run()}
      >
        <FontAwesomeIcon icon={faTableRowsAddAbove} />
        Ajouter une ligne au-dessus
      </button>
      <button
        type="button"
        className={editorDropdownItem}
        onClick={() => editor.chain().focus().addRowAfter().run()}
      >
        <FontAwesomeIcon icon={faTableRowsAddBelow} />
        Ajouter une ligne en-dessous
      </button>
      <button
        type="button"
        className={clsx(editorDropdownItem, editorTableMenuDanger)}
        onClick={() => editor.chain().focus().deleteRow().run()}
      >
        <FontAwesomeIcon icon={faTableRowsRemoveBelow} />
        Supprimer la ligne
      </button>
    </SplitButtonDropdown>
  </Tooltip>
)
